export type ParcialCriteriaItem = {title: string; body: string};

const EMBALAJE_BODY =
  'Etiqueta correcta, legible y trazabilidad correcta (código, descripción, OT, entre otros). Envase correcto según FT (funda, caja, entre otros), envase en buen estado, producto correctamente protegido (cerrado, sin exposición del PT). Pallet en buen estado, distribución y paletizado correcto.';

const PRESENTACION_GENERAL_BODY =
  'Libre de partículas extrañas, grumos, geles, material carbonizado, entre otros.';

/** Criterios fijos PDF parcial ID-23. */
export const PLASTYVERG_CRITERIA_ID23: ParcialCriteriaItem[] = [
  {
    title: 'PRESENTACIÓN GENERAL:',
    body: PRESENTACION_GENERAL_BODY,
  },
  {
    title: 'RESISTENCIA AL RASGADO:',
    body: 'Realizar prueba de rasgado manual, no debe rasgarse.',
  },
  {
    title: 'RESISTENCIA DEL PREPICADO:',
    body: 'No debe rasgarse con facilidad.',
  },
  {
    title: 'TRATADO EN CARA NO TRATADA:',
    body: 'Se debe verificar la ausencia de tratado con Politest de 38 dinas.',
  },
  {
    title: 'EMBALAJE:',
    body: EMBALAJE_BODY,
  },
];

/** Criterios fijos PDF parcial ID-24. */
export const PLASTYVERG_CRITERIA_ID24: ParcialCriteriaItem[] = [
  {
    title: 'CONTROL VISUAL GOMAS Y TEFLÓN:',
    body: 'Verificar,al inicio y término, el estado de gomas y teflón de la máquina, debe estar sin restos de material, ni suciedad.',
  },
  {
    title: 'PRESENTACIÓN GENERAL:',
    body: PRESENTACION_GENERAL_BODY,
  },
  {
    title: 'EMBALAJE:',
    body: EMBALAJE_BODY,
  },
];

/** Criterios fijos PDF parcial ID-25 / ID-26. */
export const PLASTYVERG_CRITERIA_ID25_26: ParcialCriteriaItem[] = [
  {
    title: 'PRESENTACIÓN GENERAL:',
    body: PRESENTACION_GENERAL_BODY,
  },
  {
    title: 'EMBALAJE:',
    body: EMBALAJE_BODY,
  },
];

const normalizeTitulo = (titulo?: string | null) => String(titulo || '').toUpperCase();

/** Devuelve los ítems de criterios según marcador en tituloTarea, o null si no aplica. */
export const getPlastyvergParcialCriteriaItems = (titulo?: string | null): ParcialCriteriaItem[] | null => {
  const normalized = normalizeTitulo(titulo);
  if (!normalized) return null;
  if (normalized.includes('ID-23')) return PLASTYVERG_CRITERIA_ID23;
  if (normalized.includes('ID-24')) return PLASTYVERG_CRITERIA_ID24;
  if (normalized.includes('ID-25') || normalized.includes('ID-26')) return PLASTYVERG_CRITERIA_ID25_26;
  return null;
};

const getTaskCriteriaTitulo = (task: any) =>
  task?.tituloTarea || task?.modeloTarea?.titulo || task?.titulo || '';

/**
 * Resuelve el título a usar para elegir criterios del pie:
 * prioriza la primera tarea cuyo tituloTarea (o modelo) matchee un ID conocido;
 * si no, usa el padre.
 */
export const resolveParcialCriteriaTitulo = (params: {parentTask?: any; tasks?: any[]} = {}) => {
  for (const task of params.tasks || []) {
    const titulo = getTaskCriteriaTitulo(task);
    if (titulo && getPlastyvergParcialCriteriaItems(titulo)) {
      return titulo;
    }
  }

  const parent = params.parentTask;
  return parent?.tituloTarea || parent?.titulo || parent?.modeloTarea?.titulo || getTaskCriteriaTitulo(params.tasks?.[0]) || '';
};
